import { render, staticRenderFns } from "./PendingSubmissions.vue?vue&type=template&id=7e8d3d94&"
import script from "./PendingSubmissions.vue?vue&type=script&lang=js&"
export * from "./PendingSubmissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports